import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { space } from 'shared';

export const NotificationList = styled.div`
  width: 75vw;
  max-width: 420px;
  font-size: 16px;
  font-weight: ${({ theme }) => theme.fontWeightUpperBold};
  color: ${({ theme }) => theme.textColor};
  text-align: right;
  max-height: 400px;
  overflow-y: auto;
`;

export const NotificationContent = styled.div``;

export const NotificationTime = styled.div`
  margin-left: ${space(10)};
  padding: ${space(0, 10)};
  border-left: 1px solid ${({ theme }) => theme.grayE6};
  font-size: 12px;
  min-width: 77px;
`;

export const ViewAllLink = styled(Link)`
  display: block;
  padding: ${space(10)};
  border-top: 1px solid ${({ theme }) => theme.grayE6};
  text-align: center;
  font-size: 14px;
  font-weight: ${({ theme }) => theme.fontWeightSemiBold};
  color: ${({ theme }) => theme.secondary};
`;
